import{a as i}from"./chunk-52FHIE3G.js";import{b as t,c as e}from"./chunk-MA4WTRQK.js";import{a as n}from"./chunk-73EE2EXW.js";import{m as o}from"./chunk-HBP5N4FR.js";o();e();n();function s(r){i.dispatch(t({address:r,loginMethod:"extra"}))}export{s as a};
//# sourceMappingURL=chunk-57UD6CJB.js.map
